import React from 'react';

const AiModalStatusText = ({ isDestroying, isComplete }) => {
  if (isDestroying) {
    return <>Removing codes applied with AI</>;
  } else if (isComplete) {
    return <>✅ Coding complete!</>;
  } else {
    return <>Apply your existing codes to this transcript using AI.</>;
  }
};

export default AiModalStatusText;
